import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { TaskData } from '../tasksData';
import * as api from '../../shared/api/apihandler';
import { ActivatedRoute } from '@angular/router';
import { ColorList } from 'app/bars/topbar/topbarData';
import { DateUtilities } from 'app/shared/utilities/dateUtilities';
import { ActionApi, ActionUtils } from 'app/shared/api/actionApi';

@Component({
  selector: 'task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.css']
})
export class TaskListComponent implements OnInit, OnChanges {

  @Input() caseId: string | null = this.route.snapshot.paramMap.get('id');
  @Input() offerId: string | null = null;
  @Input() customerId: string | null = null;
  @Input() propertyId: string | null = null;
  @Input('options') optionsInput: TaskListOptions;
  @Input('id') inputId: string;
  @Input() updateList: any;
  @Input() service: boolean = false;
  options: TaskListOptions = {
    size: 'large'
  };
  api = new ActionApi(this.http);
  dateUtils = new DateUtilities();
  loadingActivities = false;
  allTasks: Array<TaskData>;
  toDoTasks: Array<TaskData>;
  completedTasks: Array<TaskData>;
  // activities: Array<TaskData>;
  descending = true;
  startAmount = 0;
  endAmount = 30;
  selectedItem: any | null = null;
  timeNow: Date | null = null;

  constructor(private http: HttpClient, private sharedData: SharedDataService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    // Work around for case details since case-task component does not feed caseId   
    let id = this.route.snapshot.paramMap.get('id')?.toLowerCase();
    if (!!id && !this.propertyId) {
      this.caseId = id;
    }
    this.loadActivities();
  }

  ngOnChanges(c: SimpleChanges) {
    this.loadActivities();
    if (c.optionsInput && c.optionsInput.currentValue) {
      for (const [key, value] of Object.entries(this.optionsInput)) this.options[key] = value;
    }
  }

  loadActivities() {
    if (!!this.caseId || this.updateList && !this.propertyId && !this.loadingActivities) { this.getActivitiesOnCasePagination(); }
    else if (this.propertyId && !this.loadingActivities) { this.getActivitiesOnPropertyPagination(); }
  }

  getActivitiesOnCasePagination() {
    this.loadingActivities = true;
    let activities = JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'Activities');
    let propertyManagement = JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'PropertyManagement');
    if (!!activities || !!propertyManagement) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.http.get<Array<TaskData>>(api.jubloApi + 'api/Activity/GetActivitiesOnCase/' + this.caseId, { headers }).subscribe({
        next: (data) => {
          this.allTasks = !!this.caseId ? data.filter(x => x.caseId == this.caseId) : !!this.offerId ? data.filter(x => x.offerId == this.offerId) : !!this.propertyId ? data.filter(x => x.propertyId == this.propertyId) : data;
          // console.log(this.allTasks);
          //this.checkIfOverdue(this.allTasks);
        },
        error: err => console.error(err),
        complete: () => {
          this.loadingActivities = false;
          if (!!this.allTasks && this.allTasks.length > 0) {
            this.checkIfOverdue(this.allTasks);
          } else {
            this.sortActivities();
          }
        }
      });
    }
  }

  getActivitiesOnPropertyPagination() {
    this.loadingActivities = true;
    let activities = JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'Activities');
    let propertyManagement = JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'PropertyManagement');
    if (!!activities || !!propertyManagement) {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.http.get<Array<TaskData>>(api.jubloApi + 'api/PropertyLease/GetActivitiesOnPoperty/' + this.propertyId + '/0/100', { headers }).subscribe({
        next: (data) => {
          // Taurus type for 'ydelsesopgave' = '2fbd2abb-bc27-4a20-a4f9-72e8f4253ff3'
          this.allTasks = this.service ? data.filter(x => x.activityType.id == '2fbd2abb-bc27-4a20-a4f9-72e8f4253ff3') : data.filter(x => x.activityType.id != '2fbd2abb-bc27-4a20-a4f9-72e8f4253ff3');
          //console.log(this.allTasks);
        },
        error: err => console.error(err),
        complete: () => {
          this.loadingActivities = false;
          if (!!this.allTasks && this.allTasks.length > 0) {
            this.checkIfOverdue(this.allTasks);
          } else {
            this.sortActivities();
          }
        }
      });
    }
  }

  checkIfOverdue(data: Array<TaskData>) {
    let overdue = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i]['status']['id'] == '7cb83847-96ee-4567-8555-b9d770ff16c0' && new Date(data[i]['dueDateTime']).getTime() < Date.now()) {
        overdue.push(data[i]['id']);
      }
      if (i == data.length - 1) {
        if (overdue.length > 0) {
          const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
          this.http.patch(api.jubloApi + 'api/Activity/SetOverdue', overdue, { headers }).subscribe({
            error: err => console.error(err),
            complete: () => {
              this.sortActivities();
            }
          });
        } else {
          this.sortActivities();
        }
      }
    }
  }

  lateDate(dateTime: string) {
    if (new Date(dateTime).getTime() < new Date().getTime()) return true
    return false
  }

  trackById(task) {
    return task.id;
  }

  sortActivities() {
    this.allTasks.sort((a, b) => {
      let dateA = new Date(a.dueDateTime).getTime();
      let dateB = new Date(b.dueDateTime).getTime();
      if (this.descending) {
        return dateB - dateA;
      } else {
        return dateA - dateB;
      }
  }).slice(0, this.endAmount);
    this.toDoTasks = this.allTasks.filter(x => x.status.id != '8a7883dd-21b7-41ee-9e6e-b0e11992eb18' && x.status.id != '575cad61-42a1-48e1-9c2c-6e1fd1cd9026');
    this.completedTasks = this.allTasks.filter(x => x.status.id == '8a7883dd-21b7-41ee-9e6e-b0e11992eb18' || x.status.id == '575cad61-42a1-48e1-9c2c-6e1fd1cd9026');
    console.log(this.completedTasks)
    this.loadingActivities = false;
    //console.log(this.allTasks);
  }

  openItemSlide(item: TaskData, event) {
    this.selectedItem = null;
    if (this.timeNow) { return; }
    this.timeNow = new Date();
    document.getElementById('editTaskItemSliderModalBtn').click();
    this.loadTask(item.id)
    this.selectedItem = item;
    this.timeNow = null;
  }

  async createRecurringTask(item) {
    //console.log('adding recurrance of task')
    const date = await this.dateUtils.getNextDateInRule(item.recurrance, new Date(item.dueDateTime));
    const recurrance = await this.dateUtils.updateRule(item.recurrance, date);
    const dueDateTime = await date.toISOString();
    let newItem = ActionUtils.activityToNewActivity(item, dueDateTime, recurrance);
    this.api.postActivity(newItem).subscribe({
      error: (err) => console.error(err)
    })
  }

  loadTask(id: string) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.http.get(api.jubloApi + 'api/Activity/' + id, { headers }).subscribe({
      next: (data) => this.selectedItem = data
    })
  }

  addActivity(historyType, text, reporterType) {
    this.sharedData.setCaseActivity(historyType, text, null, reporterType, this.route.snapshot.paramMap.get('id')).subscribe({
      error: err => console.error(err)
    });
  }

  findColor(type, name) {
    let init = '';
    if (!name) return;
    init = name.trim().substring(0, 1).toUpperCase();
    switch (type) {
      case 'b':
        if (!!init) {
          return ColorList.colors[init].background;
        } else {
          return '#80b8f2';
        }
      case 'c':
        if (!!init) {
          return ColorList.colors[init].color;
        } else {
          return 'white';
        }
      default:
        if (!!init) {
          return init;
        } else {
          return '';
        }
    }
  }

}

interface TaskListOptions {
  size: 'large' | 'small'
}
